import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import MenuItemTemplates from '../../../node_modules/@getgo/chameleon-react/dist/MenuItemTemplates';
import ProfileMenu from '../../../node_modules/@getgo/chameleon-react/dist/ProfileMenu';
import AppConstants from '../../AppConstants';
import { triggerLogout, switchBackToOldView } from '../../Reducks/User/UserActions';
import './ProfileMenuComponent.css';
import { G2W, G2S, G2M, G2T } from '../../Utils/Constants';
import { trackBackToOldView } from '../../Telemetry/Mixpanel/Features/analyticsTracker';
import g2mlogosvg from './Assets/g2mlogo.svg';
import g2tlogosvg from './Assets/g2tlogo.svg';

export class ProfileMenuComponent extends Component {
  static contextTypes = {
    t: PropTypes.func.isRequired
  };
  static propTypes = {
    reduced_user: PropTypes.object,
    isBig: PropTypes.bool.isRequired,
    triggerLogout: PropTypes.func,
    switchBackToOldView: PropTypes.func
  };

  render() {
    const { isBig, reduced_user } = this.props;
    const { user = {} } = reduced_user;
    const { userKey, displayName, email } = user;
    const avatarLink = `${AppConstants.AVATAR_SERVICE_BASE_URL}/${userKey}_small.jpg`;
    const menuItemLists = this.getMenuItemLists(user);
    return <ProfileMenu user={{ displayName, email, avatarLink }} isSmall={!isBig} menuItemLists={menuItemLists} />;
  }

  getMenuItemLists(user) {
    const { t } = this.context;
    let products = [];
    if (user && user.entitlements) {
      user.entitlements.forEach(product => {
        if (G2W === product) {
          return;
        }
        let template = MenuItemTemplates.getProduct(product, AppConstants.APP_ENVIRONMENT);
        if (template) {
          if (template.title && template.title.indexOf('GOTO') > -1) {
            const newTitle = template.title.replace('GOTO', 'GOTO ');
            template = { ...template, title: newTitle };
          }
          if (G2T === product || G2M === product) {
            template.iconClass = 'menu-icon-disable';
            template.iconInlineStyle = { flex: '0 !important', marginRight: '0 !important' };
          } else {
            template.iconInlineStyle = { color: '#8B8D98' };
          }
          if (G2M === product) {
            template.titleImage = g2mlogosvg;
            template.titleImageClass = 'menuIcon';
          }
          if (G2T === product) {
            template.titleImage = g2tlogosvg;
            template.titleImageClass = 'menuIcon';
          }
        }

        if (template && G2S === product) {
          template = { ...template, iconClass: 'stageNewIcon' };
        }

        if (template) {
          products.push(template);
        }
      });
    }

    const myAccount = {
      ...MenuItemTemplates.getMenuItem('myAccount'),
      url: AppConstants.MY_ACCOUNT_URL,
      title: t('header.menu.myAccount')
    };
    const support = {
      ...MenuItemTemplates.getMenuItem('support'),
      url: AppConstants.SUPPORT_URL,
      title: t('header.menu.support')
    };
    const logout = {
      ...MenuItemTemplates.getMenuItem('logout'),
      onClick: this.props.triggerLogout,
      title: t('header.menu.logout')
    };

    let result = [products, [myAccount, support, logout]];
    const shouldAllowBackToOldView = this.props.reduced_user.entitlements.canToggleFrontendExperience;
    if (shouldAllowBackToOldView) {
      result.push([this.getOldViewItem()]);
    }
    return result;
  }
  getOldViewItem() {
    const { t } = this.context;
    return {
      id: 'oldView',
      key: 'oldView',
      title: t('header.menu.oldView'),
      iconClass: 'togo-icon togo-icon-arrow-left',
      onClick: () => {
        trackBackToOldView();
        this.props.switchBackToOldView();
      }
    };
  }
}

export default connect(
  state => ({ reduced_user: state.reduced_user }),
  {
    triggerLogout: triggerLogout,
    switchBackToOldView: switchBackToOldView
  }
)(ProfileMenuComponent);



// WEBPACK FOOTER //
// ./src/Application/Header/ProfileMenuComponent.js